/**
 * Bezpečný návrat uvnitř SPA (ochrana před open redirect).
 * Použití: query param `returnUrl` po navigaci na jinou stránku (např. výkaz práce, import → mapa).
 */
export function isSafeAppReturnUrl(path: string): boolean {
  const p = path.trim();
  if (!p.startsWith('/') || p.includes('//') || p.includes('..')) return false;
  // Validate path only — query/hash may carry tab filters (e.g. /import/polygons/:id?tab=ppd).
  const pathOnly = p.split(/[?#]/)[0] ?? p;
  return (
    /^\/objects\/[0-9a-f-]{36}$/i.test(pathOnly) ||
    /^\/polygons(\/|$)/i.test(pathOnly) ||
    /^\/maps(\/|$)/i.test(pathOnly) ||
    /^\/import(\/|$)/i.test(pathOnly) ||
    /^\/users(\/|$)/i.test(pathOnly) ||
    /^\/materials(\/|$)/i.test(pathOnly) ||
    /^\/equipment(\/|$)/i.test(pathOnly) ||
    /^\/work-report(\/|$)/i.test(pathOnly) ||
    /^\/nedodelky(\/|$)/i.test(pathOnly)
  );
}

/** Append or replace a query param on an in-app URL (path + optional query/hash). */
export function appendQueryParam(url: string, key: string, value: string): string {
  const raw = url.trim();
  if (!raw || !key) return raw;
  const hashIdx = raw.indexOf('#');
  const beforeHash = hashIdx >= 0 ? raw.slice(0, hashIdx) : raw;
  const hash = hashIdx >= 0 ? raw.slice(hashIdx) : '';
  const qIdx = beforeHash.indexOf('?');
  const path = qIdx >= 0 ? beforeHash.slice(0, qIdx) : beforeHash;
  const search = qIdx >= 0 ? beforeHash.slice(qIdx + 1) : '';
  const params = new URLSearchParams(search);
  params.set(key, value);
  const next = params.toString();
  return `${path}${next ? `?${next}` : ''}${hash}`;
}
